import { classnames } from '@aibees/shared/utils';
import { Box, Divider, Typography } from '@mui/material';
import { memo } from 'react';
import { TestimonialAuthor } from '../testimonial-author';
import { TestimonialCompany } from '../testimonial-company';
import * as SX from './sx';
import type { TestimonialCardLeaderProps as Props } from './types';

export const TestimonialCardLeader = memo(
  ({ testimonial, className }: Props) => {
    const { name, role, company, headline, avatar, logo, quote, url } =
      testimonial;

    return (
      <Box
        component="a"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={classnames('TestimonialCardLeader', className)}
        sx={SX.root}
      >
        <TestimonialAuthor
          name={name}
          role={role}
          company={company}
          avatar={avatar}
          badgeLabel="Leaders"
          badgeColor="warning"
        />

        <Typography variant="body2" color="grey.700" fontWeight={700} mb={1}>
          {headline}
        </Typography>

        <Typography variant="body4" color="grey.700" mb={2}>
          {quote}
        </Typography>

        <Divider />
        <TestimonialCompany company={company} logo={logo} />
      </Box>
    );
  }
);

TestimonialCardLeader.displayName = 'TestimonialCardLeader';
